import GridIcon from "../../../../assets/icons/Grid.svg?react";
import GraphIcon from "../../../../assets/icons/Graph.svg?react";
import XButton from "../../../../components/common/XButton";

const HistogramToggleButton = ({ isHistogramView, onToggle }) => {
  return (
    <XButton
      variant="close"
      onClick={onToggle}
      aria-label={isHistogramView ? "Switch to table view" : "Switch to histogram view"}
      title={isHistogramView ? "Table view" : "Histogram view"}
      aria-pressed={isHistogramView}
    >
      {isHistogramView ? <GridIcon /> : <GraphIcon />}
    </XButton>
  );
};

export default HistogramToggleButton;
